import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useRef, useState } from "react";
import Files from "react-files";
import { axios } from "../../commons";

const Dev = () => {
  const [content, setContent] = useState("기본 내용");
  const [files, setFiles] = useState([]);

  const reactFiles = useRef();

  const onFilesChange = useCallback((newFiles) => {
    setFiles(newFiles);
    // reactFiles.current.removeFiles();
    console.log(reactFiles.current.removeFiles);
  }, []);
  const onFilesError = useCallback((error, file) => {
    console.debug("error code " + error.code + ": " + error.message);
  }, []);

  const submit = useCallback(async () => {
    const form = new FormData();
    form.append("topic", "ASKING");
    form.append("content", content);

    files.forEach((file) => {
      form.append("picture", file);
    });

    try {
      const { data } = await axios.post(`/api/board/articles`, form);

      console.log({ data });
    } catch (err) {
      console.error(err);
    }
  }, [files, content]);

  return (
    <Container maxWidth="md">
      <Typography variant="h5" sx={{ mb: 2 }}>
        Multiple files
      </Typography>

      <TextField
        sx={{ mb: 2 }}
        label="내용"
        value={content}
        onChange={(ev) => {
          setContent(ev.target.value);
        }}
      />

      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Files"
          subheader={`선택된 파일 갯수: ${files.length}`}
        />
        <CardContent>
          <Files
            ref={reactFiles}
            className="files-dropzone"
            onChange={onFilesChange}
            onError={onFilesError}
            accepts={["image/*"]}
            multiple
            maxFiles={10}
            maxFileSize={1024 * 1024 * 10}
            minFileSize={0}
            clickable
          >
            <Paper>Drop files here or click to upload</Paper>
          </Files>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            onClick={() => {
              reactFiles.current.removeFiles();
            }}
          >
            Reset files
          </Button>
        </CardActions>
      </Card>

      <Button onClick={submit} variant="contained">
        새 글 쓰기
      </Button>
    </Container>
  );
};

export default Dev;
